import { IconChevronRight } from '@tabler/icons-react'
import Image from 'next/image'
import { WrapperLink } from '@/components/WrapperLink'
import trustpilotStars from '@/assets/images/refresh/trustpilot/trustpilot-stars.png'
import classes from './trustpilot.module.css'

export const TRUSTPILOT_REVIEWS_URL = 'https://www.trustpilot.com/review/generalmedicine.co'

export const RATING_LABEL = '4.7 stars from 550+ reviews'

const STARS_WIDTH = 109
const STARS_HEIGHT = 21

/** 5-star strip + reviews link (Figma Store 2.0 hero). */
export function TrustpilotStarsBadge() {
    return (
        <div className={classes.starsBadge}>
            <Image
                src={trustpilotStars}
                alt=""
                width={STARS_WIDTH * 2}
                height={STARS_HEIGHT * 2}
                style={{ width: STARS_WIDTH, height: STARS_HEIGHT }}
                aria-hidden
            />
            <WrapperLink
                href={TRUSTPILOT_REVIEWS_URL}
                target="_blank"
                rel="noopener noreferrer"
                openExternally
                className={classes.reviewsLink}
                aria-label={RATING_LABEL}
            >
                <span className={classes.starsRatingText}>{RATING_LABEL}</span>
                <IconChevronRight size={20} className={classes.chevron} aria-hidden />
            </WrapperLink>
        </div>
    )
}
